import {
  Grid,
  makeStyles,
} from "@material-ui/core";
import instance from "api/globalaxios";
// import { saveTempDetailsClaimantLawyer } from "features/TempTiacForm/ClaimantLawyerPage/questions";
// import { saveTempDetailsClaimant } from "features/TempTiacForm/ClaimantPage/questions";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import SidebarDisputes from "features/disputesRv/SidebarDisputes";
import GeneralSebiActivities from "Admin/Sebi/GeneralSebiActivities";
// import GeneralSebiActivities from "Admin/Nalsar/GeneralSebiActivities";

const useStyles = makeStyles((theme) => ({
  sidebar: {
    padding: "2rem",
    borderRight: "1px solid #BDBDBD",
    minHeight: "92vh",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "1rem",
      minHeight: 0,
      borderRight: 0,
      borderBottom: "1px solid #BDBDBD",
    },
  },
  activity: {
    padding: "2rem 4rem 2rem 2rem",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
  },
}));

export default function DisputesNalsar({
  profile,
  disputesActiveClaimant,
  disputesResolvedClaimant,
  disputesActiveRespondent,
  disputesResolvedRespondent,
  disputesActiveArbitrator,
  disputesResolvedArbitrator,
  allActivities,
  removeDisputeFromList,
}) {
  const classes = useStyles();
  const history = useHistory();

  const [activities, setActivities] = useState([]);

  async function createDispute() {
    return await instance.post("/tiaccreateprofileafterlogin/");
  }

  // const onClick = (e) => {
  //   if (profile.profile_type == "general_rv") {
  //     createDispute()
  //       .then((res) => {
  //         let tempData = {
  //           dispute_id: res.data.id,
  //           email: profile.user.email,
  //           full_name: profile.user.first_name + " " + profile.user.last_name,
  //           nationality: profile.nationality,
  //           address: profile.address,
  //           city: profile.city,
  //           region: profile.region,
  //           postal_code: profile.postal_code,
  //           country: profile.country,
  //           phone_number: profile.phone_number,
  //           fax: profile.fax,
  //         };
  //         saveTempDetailsClaimant(tempData).then(() => {
  //           localStorage.setItem("email", profile.user.email);
  //           localStorage.setItem("dispute_id", res.data.id);
  //           localStorage.setItem(
  //             "full_name",
  //             profile.user.first_name + " " + profile.user.last_name
  //           );
  //           localStorage.setItem("phone_number", profile.phone_number);
  //           // history.push("/tiac_claimant_lawyer");
  //           history.push("/resumerfa?find_active_step=true");
  //         });
  //       })
  //       .catch((err) => {
  //         alert(err.response.data.message);
  //       });
  //   } else if (profile.profile_type == "lawyer_rv") {
  //     createDispute()
  //       .then((res) => {
  //         let tempData = {
  //           dispute_id: res.data.id,
  //           email: profile.user.email,
  //           full_name: profile.user.first_name + " " + profile.user.last_name,
  //           nationality: profile.nationality,
  //           address: profile.address,
  //           city: profile.city,
  //           region: profile.region,
  //           postal_code: profile.postal_code,
  //           country: profile.country,
  //           phone_number: profile.phone_number,
  //           fax: profile.fax,
  //         };
  //         saveTempDetailsClaimantLawyer(tempData).then(() => {
  //           localStorage.setItem("email", profile.user.email);
  //           localStorage.setItem("dispute_id", res.data.id);
  //           localStorage.setItem(
  //             "full_name",
  //             profile.user.first_name + " " + profile.user.last_name
  //           );
  //           localStorage.setItem("phone_number", profile.phone_number);
  //           history.push("/resumerfa?find_active_step=true");

  //         });
  //       })
  //       .catch((err) => {
  //         alert(err.response.data.message);
  //       });
  //   }
  // };

  return (
    <Grid container>
      {/* sidebar */}
      <Grid
        item
        md={4}
        sm={5}
        xs={12}
        className={classes.sidebar}
        style={{ backgroundColor: "white", borderRight: "1px solid #E5E5E5" }}
      >
        <SidebarDisputes
          profile={profile}
          disputesActiveClaimant={disputesActiveClaimant}
          disputesResolvedClaimant={disputesResolvedClaimant}
          disputesActiveRespondent={disputesActiveRespondent}
          disputesResolvedRespondent={disputesResolvedRespondent}
          disputesActiveArbitrator={disputesActiveArbitrator}
          disputesResolvedArbitrator={disputesResolvedArbitrator}
          history={history}
          removeDisputeFromList={removeDisputeFromList}
        />
      </Grid>
      {/* activity */}
      <Grid item md={8} sm={7} xs={12} className={classes.activity}>
        {/* <Button variant="outlined" color="primary" onClick={onClick}>
          + File a new case
        </Button>
        <Box height="2rem" /> */}

        <GeneralSebiActivities
          activities={activities}
          setActivities={setActivities}
          activityTitle="Account Activity"
        />
      </Grid>
    </Grid>
  );
}
